<form class="min-w-80" [formGroup]="formGroup">
  <div class="flex flex-1 items-center justify-between px-5 py-3">
    <div class="flex flex-1 gap-3 items-center">
      <svg-icon key="note" fontSize="17px"></svg-icon>
      <h3>{{ "Lisa kommentaar" | translate }}</h3>
    </div>
    <div class="flex" [class.invisible]="!hasValue || readonly">
      <lxm-button
        type="transparent"
        padding="0"
        width="20px"
        (click)="clearComment()"
        [disabled]="readonly"
      >
        <svg-icon svg-icon-left key="trash" fontSize="16px"></svg-icon>
      </lxm-button>
    </div>
  </div>
  <div class="px-5 pb-3">
    <lxm-textarea [for]="for" class="new-memo-input" [readonly]="readonly">
      <!-- <div textarea-actions class="flex items-center h-[var(--input-min-height)]">
        <span class="send-icon"></span>
      </div> -->
    </lxm-textarea>
  </div>
</form>
